import React, { MouseEvent } from 'react'
import { FormattedMessage } from 'react-intl'
import ToggleSwitch from 'src/components/ToggleSwitch/ToggleSwitch'

import './ToggleSection.sass'

interface Option {
  title: string
  handleClick: (e: MouseEvent<HTMLSpanElement>) => void
}

interface ToggleSectionProps {
  options: {
    enabled: Option
    disabled: Option
  }
  toggle: {
    value: boolean
    handleChange: (newValue: boolean) => void
    disabled: boolean
  }
}

export default function ToggleSection ({
  options,
  toggle
}: ToggleSectionProps) {

  const { disabled, enabled } = options
  const { disabled: disabledToggle, handleChange, value } = toggle

  return (
    <div
      className={`switcher-container ${value ? 'allow' : 'not-allow'} ${disabledToggle ? 'disabled' : ''}`}
    >
      <span className="switcher-not-allow" onClick={disabled.handleClick}>
        <FormattedMessage id={disabled.title} />
      </span>
      <ToggleSwitch
        value={value}
        onChange={handleChange}
        disabled={disabledToggle}
      />
      <span className="switcher-allow" onClick={enabled.handleClick}>
        <FormattedMessage id={enabled.title} />
      </span>
    </div>
  )
}
